import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { useContext } from 'react';
import { OverlayContextProvider, OverlayContext, overlayContextDefaults } from '@wix/da-react-context/pkg/OverlayContext';
import { DeviationTypes } from '../../types/deviation';
import { getDeviationType } from '../_helpers';
import { useDeviationAttributes } from './useDeviationAttributes';
/** almost same as useContext(OverlayContext), but with correct defaults */ export function useOverlayContext(deviation) {
    const { isFavouritable, isCommentable } = useDeviationAttributes(deviation, false);
    const deviationType = getDeviationType(deviation);
    const canShowTitle = ![
        DeviationTypes.JOURNAL,
        DeviationTypes.LITERATURE,
        DeviationTypes.POLL,
        DeviationTypes.STATUS,
        DeviationTypes.TIER
    ].includes(deviationType);
    const rawContext = useContext(OverlayContext);
    const contextOverrides = deviationType === DeviationTypes.TIER ? {
        showTitle: false,
        showAuthor: false,
        showFaveControl: false,
        showCommentControl: false,
        showBoosted: false
    } : {};
    const _ref = _object_spread({}, overlayContextDefaults, rawContext, contextOverrides), { showTitle, showFaveControl, showCommentControl, showFaveEngagementIcon, showCommentEngagementIcon } = _ref, restContext = _object_without_properties(_ref, [
        "showTitle",
        "showFaveControl",
        "showCommentControl",
        "showFaveEngagementIcon",
        "showCommentEngagementIcon"
    ]);
    return _object_spread({
        showTitle: canShowTitle && showTitle,
        showFaveControl: isFavouritable && showFaveControl,
        showCommentControl: isCommentable && showCommentControl,
        showFaveEngagementIcon: isFavouritable && showFaveControl && showFaveEngagementIcon,
        showCommentEngagementIcon: isCommentable && showCommentControl && showCommentEngagementIcon
    }, restContext);
}
export { OverlayContextProvider };

//# sourceMappingURL=useOverlayContext.js.map